module.exports = __webpack_public_path__ + "img/video.8a52e25f.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/images/video.jpeg
// module id = aGTk
// module chunks = 0